// PRAT-161: completar o perfil do cliente (e-mail confirmado por link e CPF).

export type ProfileRequirement = 'email' | 'cpf';

export type ProfileReward = {
  scope: 'pratigo' | 'store';
  kind: 'coupon' | 'points';
  /** Texto pronto: "Cupom pratiGO de R$ 10,00", "150 pontos no Clube da Pizzaria". */
  label: string;
  discount_type?: 'AMOUNT' | 'PERCENTAGE';
  discount?: number;
  validity_days?: number;
  points?: number;
};

export type ProfileCompletion = {
  percent: number;
  items: { name: boolean; phone: boolean; email: boolean; cpf: boolean; birth_date?: boolean };
  email: {
    /** E-mail real (nunca o genérico que o sistema cria). */
    value: string | null;
    is_generic: boolean;
    verified: boolean;
    /** E-mail aguardando o clique no link. */
    pending: string | null;
  };
  cpf: string | null;
  /** AAAA-MM-DD; opcional, fora da recompensa (CRM). */
  birth_date?: string | null;
  requirements: ProfileRequirement[];
  /** Já cumpre o que a recompensa exige. */
  complete: boolean;
  /** Só as recompensas ligadas e ainda não ganhas. Vazio = não prometer prêmio. */
  rewards: ProfileReward[];
};

export const COMPLETION_ENDPOINT = 'api/app/profile/completion';
export const EMAIL_ENDPOINT = 'api/app/profile/email';
